var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-container"},[_c('img',{attrs:{"src":require("@/assets/icon-warning-error.svg"),"alt":"Error","width":"15px"}}),_c('div',[(_vm.title)?_c('div',{staticClass:"message-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.subtitle)?_c('div',{staticClass:"message-subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }